import { gsap } from 'gsap';
import { useEffect } from 'react';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import DriveCharge, { PAGE_TYPE } from '@elem/compCommon/DriveCharge';
import TabInfo from './components/tabinfo';
import Multicharge from './components/multicharge';
import Section2 from './components/Section2';
import Section3 from './components/Section3';
import Section3New from './components/Section3New';
import Section5 from './components/Section5';
import Section8 from './components/Section8';
import Section10 from './components/Section10';
import Section10_PH from './components/Section10_PH';
import Section12 from './components/Section12';
import Section13 from './components/Section13';
import Section14 from './components/Section14';
import Section15 from './components/Section15';
import Section16 from './components/Section16';
import Section17 from './components/Section17';
import Section18 from './components/Section18';
import Section19 from './components/Section19';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { heightListen } from '@/utils/animationUtils';
import IRAFooter from '@/components/IRAComp/IRAFooterNew';
import OtherList from '@/components/ProductCommon/OtherList';
import ProductRecommand from '@elem/compCommon/ProductRecomand';
import { ItfProductRecommandProps } from '@elem/compCommon/ProductRecomand/type';

gsap.registerPlugin(ScrollTrigger);
const showNewComponents = ['us', 'ca', 'uk', 'de', 'fr', 'it', 'es', 'cis', 'mx', 'br', 'ph'];

export default function GsapA() {
    const { useRouter, gloproductlist, useLang } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_new');

    const product: any = {
        us: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        za: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_max', 'product_ps_river_river_pro_720'],
        cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_river_river_256'],
        eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        br: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
        mx: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
        nl: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
        ph: ['product_ps_river_703', 'product_ps_delta_delta_3', 'product_ps_delta_delta_2'],
    };
    console.log(gloproductlist);
    const otherProductData = getDetaileMoreProducts(
        gloproductlist,
        product[locale] || product.us,
        '',
        '',
        `https://${locale}.ecoflow.com/collections/portable-power-stations`,
    );

    const props: ItfProductRecommandProps = {
        theme: 'black',
        more: `https://${locale}.ecoflow.com/collections/smart-devices`,
        data: [
            {
                productId: '9935698034964',
                variantId: '51194372948244',
            },
            {
                productId: '9935697510676',
                variantId: '51194371211540',
            },
            {
                productId: '9935709536532',
                variantId: '51194412302612',
            },
        ],
    };

    useEffect(() => {
        gsap.config({
            force3D: false,
        });
        const listener = heightListen(document.querySelector('.gsapa'), () => {
            ScrollTrigger.refresh();
            ScrollTrigger.update();
        });

        return () => {
            ScrollTrigger.getAll().forEach((v) => {
                v?.kill();
            });
            listener.clear();
        };
    }, []);

    return (
        <>
            <div className="blockWrapper">
                <div className="section2">
                    {/* 字体聚光动效 */}
                    <Section2 />
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section3">
                    {/* 一图看懂
                     2023-03-15 us ca
                     2023-03-23 uk de fr it es ru cis
                     */}
                    {showNewComponents.includes(locale) ? <Section3New /> : <Section3 />}
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section4">
                    <h5 className="line1 font-family-extrabold">{t('3Pt6kWh_25kWh_capacity')}</h5>
                    <h2 className="line2 font-family-extrabold">{t('PYH')}</h2>
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section5">
                    {/* 白天黑夜动效 */}
                    <Section5 />
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section6">
                    {/* Tab切换 */}
                    <TabInfo />
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section7 GtmModuleData-section" data-section-id={'section7'} data-section-title={t('AC_output')}>
                    <div className="line1 font-family-extrabold">{t('AC_output')}</div>
                    <div className="line2 font-family-extrabold">
                        {t.rich('AC_output_sub_title_pc', {
                            line1: (child: string) => <strong>{child}</strong>,
                        })}
                    </div>
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section8">
                    {/* 家庭充电动画(流水线条) */}
                    <Section8 />
                </div>
            </div>
            {locale === 'jp' && <Section17 />}
            <div className="blockWrapper">
                <div className="section9 GtmModuleData-section" data-section-id={'section9'} data-section-title={t('FlowCharge')}>
                    <h4 className="subTitle font-family-extrabold">{t('Introducing')}</h4>
                    <h2 className="mainTitle font-family-extrabold">{t('FlowCharge')} </h2>
                    <p className="text font-family-semibolder">{t('flow_charge_desc')}</p>
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section10">
                    {/* 卡片 */}
                    {locale === 'ph' ? <Section10_PH /> : <Section10 />}
                    <p className="sec10-memo">{t('sec10_memo')}</p>
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section11">
                    {/* 充电速度对比 */}
                    <Multicharge />
                </div>
            </div>
            <DriveCharge locale={locale} pageType={PAGE_TYPE.DELTA_PRO} />
            {showNewComponents.includes(locale) && (
                <div className="blockWrapper">
                    <div className="section18">
                        <Section18 />
                    </div>
                </div>
            )}
            {['us', 'br', 'mx'].includes(locale) && (
                <div className="blockWrapper">
                    <div className="section19">
                        <Section19 />
                    </div>
                </div>
            )}
            {!['nl'].includes(locale) && (
                <div className="blockWrapper">
                    <div className="section12">
                        {/* 无限端口介绍（无动效） */}
                        <Section12 />
                    </div>
                </div>
            )}
            {!['nl'].includes(locale) && (
                <div className="blockWrapper">
                    <div className="section13">
                        {/* 电池包连接介绍，(充电口动效) */}
                        <Section13 />
                    </div>
                </div>
            )}
            <div className="blockWrapper">
                <div className="section14">
                    {/* 逆变技术介绍 (图片渐隐切换动效) */}
                    <Section14 />
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section15">
                    {/* 行李箱把手 (把手伸出动效) */}
                    <Section15 />
                </div>
            </div>
            <div className="blockWrapper">
                <div className="section16">
                    {/* app控制 (无动效) */}
                    <Section16 />
                </div>
            </div>
            {['us', 'br', 'mx'].includes(locale) && (
                <IRAFooter borderTopColor="transparent" bgColor="transparent" boxStyle={{ margin: '0 auto 90px', width: '1120px' }} />
            )}
            {/* 其他产品推荐 */}
            {['nl'].includes(locale) ? <ProductRecommand {...props} /> : <OtherList theme="black" data={otherProductData} />}
        </>
    );
}
